import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { openWhatsApp } from "@/lib/constants";

export const FloatingWhatsApp = () => (
  <motion.button
    data-testid="floating-whatsapp-button"
    initial={{ opacity: 0, scale: 0 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.8, type: "spring", stiffness: 200, damping: 16 }}
    onClick={() =>
      openWhatsApp(
        "Olá HB Solar Energia! Gostaria de solicitar um orçamento gratuito. Vim pelo site hbsolarenergia.com.br"
      )
    }
    aria-label="Falar no WhatsApp"
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
  >
    <span className="pointer-events-none opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 rounded-full bg-[#0B192C] text-white text-xs font-bold px-4 py-2.5 shadow-xl whitespace-nowrap">
      Fale com a gente agora
    </span>
    <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_12px_32px_rgba(37,211,102,0.45)] transition-transform duration-300 group-hover:scale-110">
      <span className="absolute -top-0.5 -right-0.5 h-3.5 w-3.5 rounded-full bg-green-400 border-2 border-white pulse-dot" />
      <MessageCircle className="h-7 w-7 text-white" fill="white" strokeWidth={0} />
    </span>
  </motion.button>
);
